
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25 19C25 25.6274 19.6274 31 13 31C6.37258 31 1 25.6274 1 19C1 12.3726 6.37258 7 13 7C15.1373 7 17.1442 7.55878 18.8824 8.53822","stroke":"#69FFF5","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M21.4 15.1997C21.04 16.2188 20.0765 16.9003 18.9957 16.9003C17.9148 16.9003 16.9514 16.2188 16.5913 15.1997","stroke":"#69FFF5","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M10.9086 15.1997C10.5485 16.2188 9.58509 16.9003 8.50422 16.9003C7.42335 16.9003 6.4599 16.2188 6.09985 15.1997","stroke":"#69FFF5","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M11.5 24.5C10.1193 24.5 9 23.3807 9 22","stroke":"#69FFF5","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('line',{attrs:{"x1":"26","y1":"2","x2":"26","y2":"8","stroke":"#69FFF5","stroke-width":"2","stroke-linecap":"round"}}),_c('line',{attrs:{"x1":"23","y1":"5","x2":"29","y2":"5","stroke":"#69FFF5","stroke-width":"2","stroke-linecap":"round"}}),_c('line',{attrs:{"x1":"14","y1":"2","x2":"20","y2":"2","stroke":"#69FFF5","stroke-width":"2","stroke-linecap":"round"}}),_c('line',{attrs:{"x1":"25","y1":"12","x2":"31","y2":"12","stroke":"#69FFF5","stroke-width":"2","stroke-linecap":"round"}}),_c('line',{attrs:{"x1":"25","y1":"15","x2":"31","y2":"15","stroke":"#69FFF5","stroke-width":"2","stroke-linecap":"round"}})])
          )
        }
      }
    